import RequesterBuilder from "@/assets/plugins/mps-common/network/requester-builder";
import {PATH} from "@/constants";
import utilManager from "@/assets/plugins/mps-common/util/util-manager";
import VueAccessor from "@/assets/plugins/mps-common/app/VueAccessor";


class Multilanguage extends VueAccessor {
    _item;
    _untranslated;

    constructor(item) {
        super();
        this._item = item || {};
    }

    get raw() {
        return this._item;
    }

    get key() {
        return this._untranslated ? utilManager.getUniqueId() : this._item.multilanguageId;
    }

    /**
     * 메시지 추가를 위한 준비를 합니다.
     * 메시지 키는 필수입니다.
     */
    readyForAdd() {
        if (!this._item.messagekey) return;
        this._item.message = this._item.messagekey;
        this._item.languageCode = "ko";
        this._item.countryCode = "KR";
        this._item.groupkey = "g";
    }

    /**
     * 번역처리되지 않은 다국어행을 번역할 수 있도록 준비작업합니다.
     * @param locale
     */
    untranslate(locale) {
        this._untranslated = true;
        const {languageCode, countryCode} = utilManager.extractLocale(locale);
        this._item.languageCode = languageCode;
        this._item.countryCode = countryCode;
        this._item.groupkey = "g";
        this.vm.$set(this._item, "message", "");
    }

    async updateOrAdd() {
        if (this._item.multilanguageId) {
            this.update();
        } else {
            try {
                this.add();
            } catch (e) {
                console.error(e);
                this.vm.$alert(e.response.data.hri || "Unknown Error!");
            }
        }
    }

    async update() {
        if (!this.validate) return;
        // this.trimrize();
        await new RequesterBuilder()
            .path(PATH.MULTILANGUAGE.UPDATE)
            .setObject(this.raw)
            .enqueue();
    }

    async add() {
        if (!this.validate) return;
        // this.trimrize();
        this._item.multilanguageId = await new RequesterBuilder()
            .path(PATH.MULTILANGUAGE.ADD)
            .setObject(this.raw)
            .catch()
            .enqueue();
    }

    get validate() {
        if (!this._item.languageCode) return false;
        if (!this._item.countryCode) return false;
        if (!this._item.message) return false;
        if (!this._item.message.trim()) return false;
        if (!this._item.messagekey) return false;
        if (!this._item.messagekey.trim()) return false;
        return true;
    }

    trimrize() {
        this._item.message = this._item.message.trim();
        this._item.messagekey = this._item.messagekey.trim();
    }
}

export default Multilanguage
